{
  "promoter": {
    "auth": {
      "title": "Entra en Coreway Partners",
      "subtitle": "Para los promotores invitados al programa de Coreway.",
      "email": "Correo electrónico",
      "password": "Contraseña",
      "signIn": "Entrar",
      "signingIn": "Entrando…",
      "useLink": "Envíame un enlace para entrar",
      "usePassword": "Entrar con contraseña",
      "or": "o",
      "google": "Continuar con Google",
      "apple": "Continuar con Apple",
      "link": {
        "title": "Recibe un enlace para entrar",
        "body": "Escribe el correo al que te llegó la invitación. Te enviaremos un enlace y un código.",
        "send": "Enviarme el enlace",
        "sending": "Enviando…",
        "sentTitle": "Revisa tu correo",
        "sent": "Si {{email}} puede entrar, te llegarán un enlace y un código. Abre el enlace en este navegador o escribe el código aquí abajo.",
        "code": "Código del correo",
        "verify": "Entrar con el código",
        "verifying": "Comprobando…",
        "otherEmail": "Usar otro correo"
      },
      "errors": {
        "tooManyEmails": "Se enviaron demasiados correos. Espera unos minutos y vuelve a intentarlo.",
        "invalidEmail": "Escribe un correo válido.",
        "linkExpired": "Este enlace o código caducó o ya se usó. Pide uno nuevo.",
        "linkOtherBrowser": "Abre el enlace en el mismo navegador donde lo pediste, o escribe el código del correo.",
        "otherAccount": "Ese enlace es de otra cuenta.",
        "weakPassword": "Elige una contraseña más larga (al menos 8 caracteres).",
        "samePassword": "Esa ya es tu contraseña.",
        "invalidCredentials": "Correo o contraseña incorrectos.",
        "network": "No pudimos conectar con Coreway. Revisa tu conexión e inténtalo de nuevo.",
        "generic": "No pudimos iniciar tu sesión. Inténtalo de nuevo.",
        "oauthCancelled": "Se canceló el inicio de sesión.",
        "oauthFailed": "Falló el inicio de sesión con ese proveedor. Inténtalo de nuevo.",
        "oauthUnavailable": "Esa forma de entrar no está disponible ahora mismo.",
        "identityTaken": "Esa cuenta del proveedor ya está vinculada a otro usuario.",
        "otherAccountOAuth": "Esa cuenta del proveedor es de otro usuario."
      }
    }
  }
}
